<template>
  <LayoutContainer :id="data.cssId">
    <div
      class="rounded-[14px] left-0 w-[77%] max-tablet:w-auto"
      :class="[`dbc-block-background-${data.backgroundColor}`]"
      :style="{ padding: paddingIfBackgroundColor }"
    >
      <UtilityHeadline
        v-if="data.headlineH2"
        :class="`dbc-text-color-${data.headlineH2Color}`"
        :text="data.headlineH2"
        :level="2"
        :aos="{ fadeDirection: 'fade-right', delay: 350 }"
        :category="{ text: data.categoryH2, color: data.categoryH2Color }"
      />
      <UtilityHeadline
        v-if="data.headlineH3"
        :class="`dbc-text-color-${data.headlineH3Color}`"
        :text="data.headlineH3"
        :level="3"
        :aos="{ fadeDirection: 'fade-right', delay: 450 }"
        :category="{ text: data.categoryH3, color: data.categoryH3Color }"
      />
      <UtilityText
        v-if="data.text"
        :class="`dbc-text-color-${data.textColor}`"
        :text="data.text"
        :aos="{ fadeDirection: 'fade-right', delay: 500 }"
      />
      <UtilityButton
        v-if="data.button"
        :aos="{ fadeDirection: 'fade-right', delay: 550 }"
        :button="data.button"
        :class="''"
      />
    </div>
  </LayoutContainer>
</template>

<script setup lang="ts">
const props = defineProps<{
  content: ContentText
}>()
const data = normalizeText(props.content)

const paddingIfBackgroundColor = computed(() => {
  return data.backgroundColor !== 'white' ? '16px' : '0px'
})
</script>
